import styled, { css } from 'styled-components';
import { mediaQuery } from '../utils-css/media-query';

const headingStyle = css`
  ${({ theme }): string => theme.mixins.margin({ top: 7, bottom: 3.5 })};
  color: ${({ theme }) => theme.commons.colors.primary};
  font-family: 'Ubuntu', sans-serif;
`;

export const heading1Style = css`
  ${headingStyle};
  ${({ theme }) => theme.mixins.font('Title2')};

  ${mediaQuery.minWidth.sm} {
    ${({ theme }) => theme.mixins.font('Title1')};
  }
`;

export const Heading1 = styled.h1`
  ${heading1Style}
`;

export const heading2Style = css`
  ${headingStyle};
  ${({ theme }) => theme.mixins.font('Title3')};

  ${mediaQuery.minWidth.sm} {
    ${({ theme }) => theme.mixins.font('Title2')};
  }
`;

export const Heading2 = styled.h2`
  ${heading2Style}
`;

export const heading3Style = css`
  ${headingStyle};
  ${({ theme }) => theme.mixins.font('Title4')};

  ${mediaQuery.minWidth.sm} {
    ${({ theme }) => theme.mixins.font('Title3')};
  }
`;

export const Heading3 = styled.h3`
  ${heading3Style}
`;

export const heading4Style = css`
  ${headingStyle};
  ${({ theme }) => theme.mixins.font('Title5')};

  ${mediaQuery.minWidth.sm} {
    ${({ theme }) => theme.mixins.font('Title4')};
  }
`;
